// App state management for create app flow
const state = {
  selectedGame: '',
  // Track apps that have had AI text generation called this session
  // Key: appId, Value: true if generation was called
  aiTextGeneratedApps: {}
}

const mutations = {
  SET_SELECTED_GAME(state, gameId) {
    state.selectedGame = gameId
  },
  CLEAR_SELECTED_GAME(state) {
    state.selectedGame = ''
  },
  SET_AI_TEXT_GENERATED(state, appId) {
    state.aiTextGeneratedApps = {
      ...state.aiTextGeneratedApps,
      [appId]: true
    }
  },
  CLEAR_AI_TEXT_GENERATED(state, appId) {
    if (appId) {
      const { [appId]: _, ...rest } = state.aiTextGeneratedApps
      void _ // Suppress unused variable warning
      state.aiTextGeneratedApps = rest
    } else {
      // Clear all if no appId provided
      state.aiTextGeneratedApps = {}
    }
  }
}

const actions = {
  setSelectedGame({ commit }, gameId) {
    commit('SET_SELECTED_GAME', gameId)
  },
  clearSelectedGame({ commit }) {
    commit('CLEAR_SELECTED_GAME')
  },
  setAiTextGenerated({ commit }, appId) {
    commit('SET_AI_TEXT_GENERATED', appId)
  },
  clearAiTextGenerated({ commit }, appId = null) {
    commit('CLEAR_AI_TEXT_GENERATED', appId)
  }
}

const getters = {
  selectedGame: state => state.selectedGame,
  hasGameSelected: state => Boolean(state.selectedGame && state.selectedGame.trim()),
  hasAiTextGenerated: state => appId => Boolean(state.aiTextGeneratedApps[appId])
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
